const TEXT = {
    BANK_ID: {
        HEADING: "Sikker verifisering",
        HEADING_PREPAID_REGISTRATION: "Logg inn med BankID",
        DESCRIPTION_1: "Vi bruker BankID for din sikkerhet.",
        DESCRIPTION_ESIM:
            "Vi bruker BankID for din sikkerhet, og blir kun brukt til å verifisere at du kan installere eSIM. Personlig informasjon blir ikke lagret hos oss.",
        DESCRIPTION_2_CREDIT_CHECK:
            "Ditt fødselsnummer blir kun brukt til å gjøre en kredittsjekk, og blir ikke lagret hos oss.",
        DESCRIPTION_2_HW_ONLY_ABOVE_LIMIT: "Vi bruker BankID for å sikre din handel og redusere risikoen for svindel.",
        DESCRIPTION_2_ADDRESS_LOOKUP:
            "Ditt fødselsnummer blir kun brukt til å hente ut adresse fra folkeregisteret, og blir ikke lagret hos oss i etterkant.",
        DESCRIPTION_3_ADDRESS_LOOKUP:
            "BankID blir kun brukt til å innhente navn og adresse, fødselsnummer blir ikke lagret hos oss i etterkant.",
        DESCRIPTION_FWA_ADDRESS_LOOKUP:
            "Vi bruker BankID for å bekrefte at du er du. Du får se en oppsummering før kjøpet fullføres.",
        DESCRIPTION_PREPAID_REGISTRATION:
            "BankID blir kun brukt til å innhente navn og adresse til den som skal bruke kortet.",
        DESCRIPTION_UPDATE_PORTIN_DATE:
            "Du må gjennomføre BankID for å bekrefte din identitet før du kan endre porteringstidspunkt.",
        DESCRIPTION_ONBOARDING_B2B:
            "BankID blir kun brukt til å verifisere deg samt å innhente navn og adresse. Fødselsnummer blir ikke lagret hos oss i etterkant.",
        ERROR: "Det skjedde en feil ved verifiseringen. Prøv igjen senere.",
        GRANT_SUCCESS: "Du er nå verifisert med BankID.",
    },
    AUTH_PAGE: {
        HEADING: "Bekreft din identitet",
        INGRESS_NO: (requestor?: string): string => {
            switch (requestor) {
                case "om": // order manager
                    return "Gjennomfør BankID for å bekrefte din identitet.";
                case "sfc": // salesforce b2c
                    return "Du har vært i kontakt med Telia og vi trenger at du verifiserer deg med BankID for å ivareta din sikkerhet.";
                case "sfb": // salesforce b2b
                    return "Du har vært i kontakt med Telia og vi trenger at du verifiserer deg med BankID for å ivareta din sikkerhet.";
                case "sfo": // salesforce onecall
                    return "Du har vært i kontakt med OneCall og vi trenger at du verifiserer deg med BankID for å ivareta din sikkerhet.";
                case "sfm": // salesforce mycall
                    return "Du har vært i kontakt med MyCall og vi trenger at du verifiserer deg med BankID for å ivareta din sikkerhet.";
                case "du":
                    // MDU / SDU forms are going to be created at telia.no
                    return "Gjennomfør BankID for å bekrefte din identitet. Deretter forhåndsutfyller vi skjemaet for deg. Vi beholder ingen data.";
                default:
                    return "Gjennomfør BankID for å bekrefte din identitet. Vi beholder ingen data.";
            }
        },
        INGRESS_EN: (requestor?: string): string => {
            switch (requestor) {
                case "om":
                    return "Complete BankID to confirm your identity.";
                case "sfc":
                case "sfb":
                    return "You have been in contact with Telia and we need you to verify yourself with BankID to protect your security.";
                case "sfo":
                    return "You have been in contact with OneCall and we need you to verify yourself with BankID to protect your security.";
                case "sfm":
                    return "You have been in contact with MyCall and we need you to verify yourself with BankID to protect your security.";
                case "du":
                    return "Complete BankID to confirm your identity. We will then pre-fill the form for you. We do not keep any data.";
                default:
                    return "Complete BankID to confirm your identity. We do not keep any data.";
            }
        },
        RESULT_TEXT: (customer: string): string => `Takk ${customer} - vi bekrefter å ha mottatt din verifisering.`,
        EN: {
            HEADING: "Confirm your identity",
            RESULT_TEXT: (customer: string): string =>
                `Thank you ${customer} - we confirm that we have received your verification.`,
            ORDER_EXPIRED: "This link has expired. Please contact us to receive a new link.",
            ORDER_NOT_FOUND: "This link is invalid. Please contact us to receive a new link.",
            BANK_ID_BUTTON: "Verify with BankID",
            CANDOUR_HEADING: "Don't have a Norwegian BankID?",
            CANDOUR_SUBHEADING: "Verify yourself with an ID card and facial recognition.",
            LANGUAGE_TOGGLE: "På Norsk",
        },
        LANGUAGE_TOGGLE_NO: "In English",
        ALREADY_VERIFIED:
            "Du har allerede verifisert deg. Vennligst benytt en annen nettleser hvis du mener dette ikke er korrekt.",
        ORDER_EXPIRED: "Denne lenken sin levetid har utløpt. Vennligst kontakt oss for å få tilsendt en ny lenke.",
        ORDER_NOT_FOUND: "Denne lenken er ugyldig. Vennligst kontakt oss for å få tilsendt en ny lenke.",
        BUTTON: {
            BANK_ID: "BankID",
        },
    },
    CANDOUR: {
        HEADING: "Har du ikke norsk BankID?",
        SUBHEADING: "Bekreft deg selv med ID-kort og ansiktsgjenkjenning.",
    },
};

export default TEXT;
